import React, { useRef, useState, useEffect } from 'react';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { uploadFile, ServiceAccountCreation,serviceFetchFailedLogs, serviceGetClinic, serviceGetDoctorByClinic, ServiceAllprogramList,serviceGetarea , getICBRegionList }from "../Services/Service";
import { CustomLoader, ModalBox,CustomLoading } from "../Services/CommonLibrary"
import History from './History';


function FileUploadText(props) {
    const onReload= props.onReload;
    const [loading, setLoading] = useState(false);
    const initial = {practice_email:'', doctor_email:'',nhs_number:'',patient_name:'',patient_email:'', patient_mobile:'', program_name:'', ptHealthDataFile:'',drNotesFile:'',area_id:'',practicelist:[],drlist:[],first_appointment_date:'',icb_region:''}
    const [count, setCount] = useState(1);
    const [values, setValues] = useState([initial]);
    // const [practicelist, setPracticelist] = useState([]);
    const [arealist, setArealist] = useState([]);
    // const [drlist, setDrlist] = useState([]);
    const [programlist, setProgramlist] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalBody, setModalBody] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [intervalPopup, setIntervalPopup] = useState(false);
    const [uidStore, setUidStore] = useState('');
    const handleClose = () =>setShowModal(false);
    const showDivision = process.env.REACT_APP_SHOW_DIVISION === 'true';
    const showICBRegion = String(process.env.REACT_APP_ICB_REGION_SHOW).trim().toLowerCase() === 'true';
    const [icbRegionList, setIcbRegionList] = useState([]);
    const handleReloadClick = () => {
        onReload();
      };
      const [intervalId, setIntervalId] = useState(null);
      const buttonRef = useRef(null);
    useEffect(() => {
        areaListfunc();
        //practiceListfunc();
        //drListfunc();
        programListfunc();
        
    },[]);

    const practiceListfunc = async (areaId,index) =>{      
        const response = await serviceGetClinic(areaId);
        // console.log(response.data.data.clinic);
        // setPracticelist(response.data.data.clinic);
        const newValues = [...values];
        newValues[index]['practicelist'] = response.data.data.clinic;
        setValues(newValues);
        
    }
    const areaListfunc = async () =>{      
        const response = await serviceGetarea('');
        console.log(response.data.data.area);
        setArealist(response.data.data.area);
        
    }
    const drListfunc = async (clinicId,index) =>{      
        const response = await serviceGetDoctorByClinic(clinicId);
        // setDrlist(response.data.data.doctor);
        const newValues = [...values];
        newValues[index]['drlist'] = response.data.data.doctor;
        setValues(newValues);
    }
    const programListfunc = async () =>{      
        const response = await ServiceAllprogramList();
        setProgramlist(response.data.data);
    }

    useEffect(() => {
    const loadInitialData = async () => {
        try {
            const icbResponse = await getICBRegionList();
            console.log("ICB Region Response:", icbResponse);
            
            if (icbResponse?.data?.status === "success") {
                setIcbRegionList(icbResponse.data.data);
            }
        } catch (error) {
            console.error("Failed to load initial data:", error);
        }
    };

    loadInitialData();
    }, []); // Empty array means this runs ONCE on mount

  const addTextBox = () => {
    setCount(count + 1);
    setValues([...values, initial]);
  };

  const removeTextBox = (index) => {
    // alert(index)
    setCount(count - 1);
    setValues(values.filter((value, i) => i !== index));
  };

  const resetForm = () => {
    setCount(1);
    setValues([initial]);
    // Clear all file inputs
    for (let i = 0; i < 100; i++) {
      const ptHealthDataInput = document.getElementById(`ptHealthDataFile_${i}`);
      const drNotesInput = document.getElementById(`drNotesFile_${i}`);
      if (ptHealthDataInput) ptHealthDataInput.value = "";
      if (drNotesInput) drNotesInput.value = "";
    }
  };

  const handleChange = (event, index) => {
    
    const newValues = [...values];
    const name = event.target.name
    console.log(event.target.name)
    if(event.target.type=='file'){
        // const id = event.target.getAttribute('data-index');
        console.log(event.target.files);
        if(event.target.files[0].type=='application/pdf'){
            newValues[index][name] = event.target.files[0];    
        }else{
            newValues[index][name] = '';
            document.getElementById(event.target.id).value = "";
        }
        
    }else if(event.target.name=="nhs_number"){

        const regex = /^[0-9-]*$/;
        if (event.target.value === '' || regex.test(event.target.value)) {
            newValues[index][name] = event.target.value;
        }

        // event.target.value =  event.target.value.replace(/\D/g, "");
        // newValues[index][name] = event.target.value;
    }else if(event.target.name=="area_id"){
        newValues[index][name] = event.target.value;
        newValues[index]['practice_email'] = '';
        newValues[index]['doctor_email'] = '';
        newValues[index]['drlist'] = [];

       if (event.target.options) {
            const area_id = event.target.options[event.target.selectedIndex].getAttribute("data-areaid");
            practiceListfunc(area_id, index);
        } else {
            const defaultArea = arealist.find(a => a.areaName === "L L P");
            if (defaultArea) {
                practiceListfunc(defaultArea.areaId, index);
            }
        }
        
    }else if(event.target.name=="practice_email"){
        newValues[index][name] = event.target.value;
        const clinic_id = event.target.options[event.target.selectedIndex].getAttribute("data-clinicid");
        newValues[index]['doctor_email'] = '';
        newValues[index]['drlist'] = [];
        drListfunc(clinic_id,index);
    }else if(event.target.name=="patient_mobile"){
        newValues[index][event.target.name] = event.target.value.replace(/\D/g, "");
    }else{
        newValues[index][name] = event.target.value;
    }
    setValues(newValues);
  };
    useEffect(() => {
        if (!showDivision && arealist.length > 0) {
            const defaultArea = arealist.find(a => a.areaName === "L L P");
            if (!defaultArea) return;

            const updatedValues = values.map((row, index) => {
                // Load practice list per row
                practiceListfunc(defaultArea.areaId, index);
                return {
                    ...row,
                    area_id: "L L P"
                };
            });

            setValues(updatedValues);
        }
    }, [showDivision, arealist, count]);

  const submitValues = (e) => {
    e.preventDefault();
    setLoading(true);
    
    const formData = new FormData();
    values.forEach((formField, index) => {
      let currentFormField = { ...formField };
      if (!showDivision) {
        currentFormField.area_id = 'L L P';
      }
      console.log('**************************--------***********');
      console.log(currentFormField);
      formData.append(`text[${index}]`, JSON.stringify(currentFormField));
      formData.append(`ptHealthDataFile[${index}]`, currentFormField.ptHealthDataFile);
      formData.append(`drNoteFile[${index}]`, currentFormField.drNotesFile);
    });
    // setLoading(false);
    const fetchLiveUploadedData = (uidStore) => {
        serviceFetchFailedLogs(uidStore,'live')
                    .then((res) => {

                        if(res?.data?.data[0].queueStatus == 2) {setUidStore('');clearInterval(intervalId);handleReloadClick();}
                        
                        const modalBodyComponent= res.data.data.length > 0 ? 
                            res.data.data.map((item,i) => 
                                                        <tr key={i}>
                                                                <td>
                                                                    <span style={item.status=='Success' ? {color:"green"} : {color:"red"}}>
                                                                        {item.status=='Success'?"Account Created":"Invalid Data"}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span style={item.statusMsg=='Success' ? {color:"green"} : {color:"red"}}>{item.status=='Success'?"Account Created":item.statusMsg}</span>
                                                                </td>
                                                            { item.rawJson.map((data,i) =>
                                                                <td key={i}>{data}</td>
                                                                )}
                                                    </tr>
                            ) : 
                            <tr><td colSpan="2">No Records</td></tr>;

                        const html = <><div className="table-responsive"><table className="table"><thead><tr><th scope="col">Status</th><th scope="col">Reason</th>
                        <th scope='col'>Practice Name</th>
                        <th scope='col'>Doctor email</th>
                        <th scope='col'>NHS number</th>
                        <th scope='col'>Patient Name</th>
                        <th scope='col'>Patient Email</th>
                        <th scope='col'>Patient Mobile</th>
                        <th scope='col'>Program Name</th>
                        <th scope='col'>Division</th>
                       </tr></thead><tbody>{modalBodyComponent}</tbody></table></div>{res.data.data[0].queueStatus != 2 ?<CustomLoading /> : null}</>
                       
                        setModalBody(html);
                        handleReloadClick();

                        }
                    );
    }
    ServiceAccountCreation(formData)
    .then((response) => {
        setLoading(false);
        
        if(typeof(response)!=='undefined'){
            let clas = (response.data.status == "1") ? 'success' : 'danger';
           
                        let uploadStatus = response.data.status;
                        if(uploadStatus == 3){
                            setShowModal(true)
                            // console.log(response.data.data.message);
                            const modalBodyComponent= response.data.data.message.length > 0 ? response.data.data.message.map((data, i) => (
                                <tr key={i}>
                                    <td><span style={data[10]=='Success' ? {color:"green"} : {color:"red"}}>{data[10] == 'Success' ? 'Valid Data' : 'Invalid Data'}</span></td>
                                    <td >
                                        <span style={data[10]=='Success' ? {color:"green"} : {color:"red"}}>
                                            {data[10] == 'Success' ? 'Valid Data' : 
                                                data[10].split(',').map((item, index) => {
                                                    return (index === 0) ? item : [<br key={index} />, item];
                                                })
                                            }
                                        </span>
                                    </td>
                                    <td>{data[0]}</td>
                                    <td>{data[1]}</td>
                                    <td>{data[2]}</td>
                                    <td>{data[3]}</td>
                                    <td>{data[4]}</td>
                                    <td>{data[5]}</td>
                                    <td>{data[6]}</td>
                                    <td>{data[7]}</td>
                                </tr>
                            )) : <tr><td colSpan="2">No Records</td></tr>;
                            const html = <div className="table-responsive"><table className="table"><thead><tr> <th scope='col'>Status</th>
                            <th scope='col'>Reason</th>
                            <th scope='col'>Practice Name</th>
                            <th scope='col'>Doctor email</th>
                            <th scope='col'>NHS number</th>
                            <th scope='col'>Patient Name</th>
                            <th scope='col'>Patient Email</th>
                            <th scope='col'>Patient Mobile</th>
                            <th scope='col'>Program Name</th>
                            <th scope='col'>Division</th></tr></thead><tbody>{modalBodyComponent}</tbody></table></div>
                            setModalBody(html);
                            setModalTitle(<span style={{"backgroundColor": "#e3b6b6",padding: "5px",borderRadius: "10px"}}> 0 Accounts Created. Please Resolve Below Errors And Update Patient details again.</span>)
                        }else if(uploadStatus == 1){
                            setUidStore(response.data.uid);
                            console.log("2nd call")
                            setShowModal(true);
                            setModalTitle('Alert!')
                            setModalBody(<span> Patient Details added Successfully, Account creation is in progress...... </span>);
                            setIntervalPopup(true);

                            const timeoutId = setTimeout(() => {
                                setShowModal(false);
                               fetchLiveUploadedData(response.data.uid);
                                setShowModal(true);
                                setIntervalPopup(true);
                                console.log("timeout ===",response.data.uid);
                                setModalTitle('Status: Uploaded File. Account Creation In-Progress...')
                                handleReloadClick();
                              }, 5000);
                            
                        }else if(uploadStatus == 4){
                            setShowModal(true);
                            setModalTitle('Alert!');
                            setModalBody(response.data.data.message);
                        }


            // -------------------------------------
            if(response.data.status == "1"){
                resetForm();
            }
            handleReloadClick();
            // onShowAlert(response.data.data.message,true,clas);    
        }
    })
    // console.log(values);
  };
  
    return (
        <>
            <section className='profile-box1'>
            <div className="row ">
                <div className="col-md-12">
                <h1 className='title mb-4'>Patient Account Creation</h1>
                    <div className='table-responsive'>
                    <div className=''>
                    
                    
                    <form className='' onSubmit={submitValues}> 
                    <div className="table-responsive text-nowrap mb-2">
                        
                        <table className="table table-striped">
                        <thead>
                            <tr>
                            {/* <th>#</th> */}
                            <th>*NHS No.</th>
                            <th>*Patient Name</th>
                            <th>Patient Email</th>
                            <th>*Patient Mobile</th>
                            { !showDivision ? "" : <th>*Division</th>}
                            { showICBRegion ? <th>First Consultation Date</th> : null}
                            <th>Practice</th>
                            <th>Doctor</th>
                            <th>*Program</th>
                            { showICBRegion ? <th>*ICB Region</th> : null }
                            { showICBRegion ? <th>*Patient Referal Letter (only pdf)</th> : <th>*Patient Summary (only pdf)</th> }
                            { showICBRegion ? <th>Relevant Information (other document) </th>:<th>Doctor Note (only pdf)</th> }
                            <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {values.map((value, index) => (
                            <tr key={index}>
                                {/* <th scope="row">{index+1}</th> */}
                                <td><input style={{width:"auto"}} className="form-control form-control-sm centered-placeholder" required value={value.nhs_number} name="nhs_number" onChange={(event) => handleChange(event, index)} placeholder="NHS Number" maxLength="10"  type="text" /></td>
                                <td><input style={{width:"auto"}} className="form-control form-control-sm centered-placeholder" required value={value.patient_name} name="patient_name" onChange={(event) => handleChange(event, index)} placeholder="Patient Name"  type="text" /></td>
                                <td><input style={{width:"auto"}} className="form-control form-control-sm centered-placeholder"  value={value.patient_email} name="patient_email" onChange={(event) => handleChange(event, index)} placeholder="Patient Email"  type="email" /></td>
                                <td><input style={{width:"auto"}} className="form-control form-control-sm centered-placeholder" required value={value.patient_mobile} name="patient_mobile" onChange={(event) => handleChange(event, index)} placeholder="Patient Mobile"  type="text" maxLength='10' /></td>
                                
                                {
                                    !showDivision ? (
                                        <td style={{ display: 'none' }}>
                                            <input type="hidden" name="area_id" value="L L P" />
                                        </td>
                                    ) : (
                                        <td>
                                            <select 
                                                style={{width:"auto"}} 
                                                id="areaSelect" 
                                                name="area_id"  
                                                value={values[index].area_id} 
                                                className='form-control form-control-sm' 
                                                required 
                                                onChange={(event) => handleChange(event, index)} 
                                            >
                                                <option value="">-- SELECT Division --</option>
                                                {arealist.length > 0 ? arealist.map((data, i) => (
                                                    <option value={data.areaName} data-areaid={data.areaId} key={i}>
                                                        {data.areaName}
                                                    </option>
                                                )) : null}
                                            </select>
                                        </td>
                                    )
                                }
                                {
                                    showICBRegion ? <td><input style={{width:"auto"}} className="form-control form-control-sm centered-placeholder"  value={value.first_appointment_date} name="first_appointment_date" onChange={(event) => handleChange(event, index)} placeholder="First Appointment Date"  type="date" /></td> : null
                                }
                                <td><select style={{width:"auto"}} id="clinicSelect" name="practice_email" value={value.practice_email} className='form-control form-control-sm'  onChange={(event) => handleChange(event, index)} >
                                        <option value="">-- SELECT Practice --</option>
                                        
                                        {value.practicelist.length>0 ? value.practicelist.map((data, i) => (
                                            <option value={data.email} data-clinicid={data.clinicId}  key={i}>{data.name}</option>
                                        )) : null}
                                    </select>
                                </td>
                                <td>
                                    <select style={{width:"auto"}} id="drSelect" name="doctor_email"  value={values[index].doctor_email} className='form-control form-control-sm'  onChange={(event) => handleChange(event, index)} >
                                        <option value="">-- SELECT Doctor --</option>
                                        
                                        {value.drlist.length>0 ? value.drlist.map((data, i) => (
                                            <option value={data.email}  key={i}>{data.drName}</option>
                                        )) : null}
                                    </select>
                                </td>
                                
                                <td>
                                    <select style={{width:"auto"}} id="programSelect" name="program_name"  value={values[index].program_name} className='form-control form-control-sm' required onChange={(event) => handleChange(event, index)} >
                                        <option value="">-- SELECT Program --</option>
                                        
                                        {programlist.length>0 ? programlist.map((data, i) => (
                                            <option value={data.programName}  key={i}>{data.programName}</option>
                                        )) : null}
                                    </select>

                                </td>
                                { showICBRegion ? (<td>
                                    <select style={{width:"auto"}} id="icbRegionSelect" name="icb_region"  value={values[index].icb_region} className='form-control form-control-sm'  onChange={(event) => handleChange(event, index)} >
                                        <option value="">-- SELECT ICB Region --</option>
                                        {icbRegionList.length>0 ? icbRegionList.map((data, i) => (
                                            <option value={data.icb_key}  key={i}>{data.icb_name}</option>
                                        )) : null}
                                    </select>
                                </td>) : null
                                }
                                <td><input id={`ptHealthDataFile_${index}`} style={{width:"auto"}} className="form-control form-control-sm" required  type="file" data-index={index}  name="ptHealthDataFile" accept="application/pdf" onChange={(event) => handleChange(event, index)} /></td>
                                <td><input id={`drNotesFile_${index}`} style={{width:"auto"}} className="form-control form-control-sm"           type="file" data-index={index}  name="drNotesFile" accept="application/pdf" onChange={(event) => handleChange(event, index)} /></td>

                                <td>{count>1 ? <button type="button" style={{width: "auto"}} className="btn btn-danger btn-sm" onClick={() => removeTextBox(index)}><i className="bi bi-trash"></i></button> : null}</td>
                            </tr>
                            ))}
                           
                        </tbody>
                        </table>
                    </div>
                    {count<100?<button type="button" style={{width: "auto"}} className="btn btn-success btn-sm me-3 mb-2" onClick={addTextBox}><i className="bi bi-plus"></i> Add More</button>:null}
                    <button type="submit" style={{width: "auto"}} className="btn btn-primary btn-sm mb-2" name="submit" >Submit ({values.length})</button>
                    </form>
                </div>
                    </div>
                </div>
                </div>


                
            
            </section>
            {showModal?<ModalBox handleClose={handleClose} showModaln={showModal} titlen={modalTitle} bodyn={modalBody}/>:null}
            { loading ? <CustomLoader /> : null }
        </>
    );
}
export default FileUploadText;